import React from 'react';

function OurStory() {
  return (
    <section className="py-16 md:py-24">
      <div className="max-w-[1180px] mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <h2 className="font-display text-[2rem] md:text-[2.6rem] font-bold text-navy-deep leading-tight">
              A Personal
              <span className="block text-sky">Mission</span>
              <span className="block text-lg md:text-xl font-sans font-normal text-navy/60 mt-2">
                Born from Love
              </span>
            </h2>

            <div className="space-y-4 mt-6">
              <p className="text-[1.05rem] text-navy leading-[1.65]">
                When My Great Grandmother Mary Experienced Struggles With Independence In The
                Shower, It Broke My Heart. I Realized That Millions Of Families Face This Same
                Fear Every Day.
              </p>
              <p className="text-[1.05rem] text-navy leading-[1.65]">
                November 16th Marks Great Grandmother Mary&apos;s Birthday, And I Can&apos;t
                Think Of A Better Way To Honor Her Legacy Than By Launching Goldilocks Smart
                Solutions.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-nu overflow-hidden shadow-nu-out">
              <img
                src="/assets/goldie/mary-story.jpg"
                alt="Thomas Bittings Jr. with his great grandmother Mary"
                className="w-full h-[380px] md:h-[440px] object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 bg-cream shadow-nu-out rounded-2xl px-4 py-3 md:px-5 md:py-4">
              <div className="text-xs text-navy/70 mb-1">In Memory of</div>
              <div className="text-sm md:text-base font-semibold text-navy-deep">
                Great Grandmother Mary
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurStory;
